import React from 'react'

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';


type Props = {
    data: any[];
}


const PhotoGrid = (props: Props) => {
    const theme = useTheme();
        return (
        <Box>
            {props.data.map((item, i) => (
            <Box
                key={i}
                sx={{
                marginBottom: { xs: 2, sm: 3 },
                '&:last-child': { marginBottom: 0 },
                }}
            >
                <Box
                boxShadow={1}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: 2,
                    '&:hover': {
                    '& img': {
                        transform: 'scale(1.2)',
                    },
                    '& .main-item': {
                        bottom: 0,
                    },
                    },
                }}
                >
                <Box
                    component={'img'}
                    loading="lazy"
                    height={1}
                    width={1}
                    src={item.image}
                    alt="..."
                    maxHeight={{ xs: 400, sm: 500, md: 500 }}
                    sx={{
                    transition: 'transform .7s ease !important',
                    transform: 'scale(1.0)',
                    objectFit: 'cover',
                    filter:
                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                    }}
                />
                <Box
                    position={'absolute'}
                    bottom={'-100%'}
                    left={0}
                    right={0}
                    padding={4}
                    bgcolor={'background.paper'}
                    className={'main-item'}
                    sx={{ transition: 'bottom 0.3s ease 0s',  opacity: 0.8 }}
                >
                    <Box
                        component={'svg'}
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 1920 100.1"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            transform: 'translateY(-50%)',
                            zIndex: 2,
                            width: 1,
                            // opacity: 0.7
                        }}
                    >
                    <path
                        fill={theme.palette.background.paper}
                        d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
                    ></path>
                    </Box>
                    <Typography variant={'h6'} fontWeight={700} gutterBottom>
                    {item.title}
                    </Typography>
                    <Typography>{item.description}</Typography>
                </Box>
                </Box>
            </Box>
            ))}
        </Box>
    );
}

export default PhotoGrid